// src/App.js
import React from 'react';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Gallery from './components/Gallery';
import WhatsAppButton from './components/WhatsAppButton';
import Projects from './components/Projects';
import Quotation from './components/Quotation';
import ErrorBoundary from './components/ErrorBoundary';
import SEOHead from './components/SEOHead';
import PerformanceOptimizer from './components/PerformanceOptimizer';
import GEOOptimizer from './components/GEOOptimizer';
import logger from './utils/logger';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Add window error handlers
window.onerror = (message, source, lineno, colno, error) => {
  logger.error('Global Error:', { message, source, lineno, colno, error });
};

window.onunhandledrejection = (event) => {
  logger.error('Unhandled Promise Rejection:', event.reason);
};


// Main Layout Component
const MainLayout = () => (
  <div className="App">
    <Navbar />
    <Home />
    <Services />
    <Testimonials />
    <Projects />
    <Gallery />
    <Quotation />
    <About />
    <Contact />
    <Footer />
    <WhatsAppButton />
  </div>
);

const App = () => {
  // Check if we're in production
  const isProduction = import.meta.env.PROD;

  return (
    <ErrorBoundary>
      <BrowserRouter>
        {/* SEO Head Component */}
        <SEOHead />
        
        {/* Performance Optimizer */}
        <PerformanceOptimizer />
        
        {/* GEO (Generative Engine Optimization) */}
        <GEOOptimizer />
        
        {/* Add security headers in production */}
        {isProduction && (
          <meta httpEquiv="Content-Security-Policy" content="default-src 'self'; img-src 'self' data: https:; style-src 'self' 'unsafe-inline';" />
        )}
        
        <Routes>
          {/* Main website routes */}
          <Route path="/" element={<MainLayout />} />


          {/* Catch all route for 404s */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
